import { FC, forwardRef, useImperativeHandle, useRef } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import V2Table from '@/common/components/Data/V2Table';
import V2Title from '@/common/components/Feedback/V2Title';
import YearDataInput from './YearDataInput';
import SpecialInput from './SpecialInput';

/**
 * @Description 单个Table
 *
 *  按照前端配置isYearData
 *  分为区分年份的表格（单行内展示第一年、第二年数据）
 *  不区分年份的表格（单行内展示两个字段）
 */
const TableModule: FC<{
  moduleConfig: any;
  form: any;
  formItemData: any;
  disabled?: boolean;
  onChange: any;
  ref?: any,
}> = forwardRef(({
  moduleConfig,
  form,
  formItemData,
  disabled,
  onChange,
}, ref) => {
  // 外部调用保存机会点
  useImperativeHandle(ref, () => ({
    onload: () => {
      (tableRef.current as any).onload();
    },
  }));

  const tableRef: any = useRef(null);
  const { title, isYearData, data, columns } = moduleConfig;

  const defaultColumns = columns.map((columnItem: any) => {
    if (isYearData) {
      return {
        ...columnItem,
        render: (_, record: any) => (
          <YearDataInput
            form={form}
            formItemData={formItemData}
            disabled={disabled}
            moduleConfig={moduleConfig}
            record={record}
            columnItem={columnItem}
            onChange={onChange}
          />),
      };
    } else {
      return {
        ...columnItem,
        render: (_, record: any) => (
          <SpecialInput
            form={form}
            formItemData={formItemData}
            disabled={disabled}
            moduleConfig={moduleConfig}
            record={record}
            columnItem={columnItem}
            onChange={onChange}
          />),
      };
    }
  });

  const loadData = () => {
    return {
      dataSource: data || [],
      count: data?.length || 0
    };
  };

  return (
    <>
      <V2Title
        type='H2'
        divider
        text={title}
        className='pb-16'
      />
      <V2Table
        ref={tableRef}
        rowKey={isYearData ? 'name' : 'key'}
        onFetch={loadData}
        defaultColumns={defaultColumns}
        hideColumnPlaceholder
        pagination={false}
        className={cs(styles.tableModule, !isYearData && styles.specialTable, 'mb-16')}
        showHeader={isYearData}
      />
    </>
  );
});

export default TableModule;
